var MainMap = (function(){
  'use strict';

  var mapGL = null;
  var container = 'map-canvas';
  var layers = [];

  var init = function() {
    if($("#"+container).length){
      if (!maplibregl.supported()) {
        $(container).find('.maplibregl-unsupported').removeClass('is-hidden');
      } else {
        let zoom = 6;
        let minZoom = 6;
        let center =  [4.86, 45.76];
        let style = styleLayerMap;
        let controls = {};

        controls = {
          navigation: {enable: 1, position: 'bottom-right'},
          geolocate: {enable: 0, position: 'bottom-right'},
          fullscreen: {enable: 1, position: 'bottom-right'},
        };

        mapGL = new MapGL(container, zoom, minZoom, center, style, controls);
        var mapObject = mapGL.getMapObject();

        mapObject.on('load', function() {
          let selectionMode = $("#" + container).hasClass('selection-map') ? true : false;

          let offersLayer = new JepOffersLayer(mapGL, true, selectionMode);
          let velovStationLayer = new VelovStationLayer(mapGL);
          layers = [offersLayer, velovStationLayer];

          $('#station-velov').click(function() {
            if(mapGL.popup.isOpen()) {
              mapGL.popup.remove();
            }

            if ($(this).is(':checked')) {
              velovStationLayer.enable();
            }
            else{
              velovStationLayer.disable();
            }
          });

          //mise à jour du aria-label du canvas
          $('.maplibregl-canvas').attr('aria-label', 'Carte des offres des JEP');
        });
      }
    }
  };

  return {
    init: init
  };

}());
